module.exports = __webpack_public_path__ + "img/footer-img-xyl.4959eb6.jpg";